export const findPathToStart = (nodes, edges, currentNodeId, visitedNodes = new Set()) => {
  // Добавляем текущую ноду в список посещенных
  visitedNodes.add(currentNodeId);
  
  // Находим все входящие соединения для текущей ноды
  const incomingEdges = edges.filter(edge => edge.target === currentNodeId);
  
  // Находим текущую ноду
  const currentNode = nodes.find(n => n.id === currentNodeId);
  if (!currentNode) return null;
  
  // Если нет входящих соединений или дошли до стартовой ноды - начинаем формировать сообщения
  if (incomingEdges.length === 0 || currentNode.type === 'start') {
    const messages = [];
    if (currentNode.type === 'dialogue') {
      const lines = currentNode.data?.text?.split('\n') || [''];
      messages.push(...lines.map(line => `(You) ${line}`));
    } else if (currentNode.type === 'image') {
      messages.push("(You: sent a sexy photo)");
    }
    return { messages: messages.slice(-30) }; // Берем последние 30 строк
  }
  
  // Для каждого входящего соединения
  for (const edge of incomingEdges) {
    // Если уже посещали эту ноду - пропускаем (защита от циклов)
    if (visitedNodes.has(edge.source)) {
      continue;
    }
    
    // Рекурсивно ищем путь от предыдущей ноды
    const result = findPathToStart(nodes, edges, edge.source, visitedNodes);
    
    // Если путь найден, добавляем текущую ноду
    if (result?.messages) {
      const messages = [...result.messages];
      
      // Добавляем ответ, если это dialogue нода
      const sourceNode = nodes.find(n => n.id === edge.source);
      if (sourceNode?.type === 'dialogue' && sourceNode.data?.answers) {
        const answerIndex = parseInt(edge.sourceHandle?.split('-')[1]);
        if (!isNaN(answerIndex) && sourceNode.data.answers[answerIndex]) {
          messages.push(`(Guy) ${sourceNode.data.answers[answerIndex].text || ''}`);
        }
      }
      
      // Добавляем текущую ноду
      if (currentNode.type === 'dialogue') {
        const lines = currentNode.data?.text?.split('\n') || [''];
        messages.push(...lines.map(line => `(You) ${line}`));
      } else if (currentNode.type === 'image') {
        messages.push("(You: sent a sexy photo)");
      }
      
      return { messages: messages.slice(-30) }; // Берем последние 30 строк
    }
  }
  
  return null;
}; 